import { Component } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';
import { SharedLavorazioniModule } from '../main/main-home/pages/lavorazioni/modules/shared-lavorazioni/shared-lavorazioni.module';

@Component({
    selector: 'app-footer',
    imports: [SharedLavorazioniModule],
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.scss'
})
export class FooterComponent {

  constructor(private authenticationService: AuthenticationService) {

  }

  viewMainHome(): boolean {
    return this.authenticationService.isLoggedIn;
  }
}
